import { DocumentLibrary } from '@client/components/_shared/documents/DocumentLibrary';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/coi/details/$id/library')({
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();

    return <DocumentLibrary entity="conflictOfInterest" entityId={id} />;
}
